import useDashboardAccess from "@/hooks/useDashboardAccess";
import { canStylistAccessRoute } from "@/utilities/dashboardAccess";
import { Button, Center, Loader, Stack, Text } from "@mantine/core";
import { Navigate, useLocation } from "react-router-dom";

export default function DashboardAccess({ children }: { children: JSX.Element }) {
  const { isManager, isResolved, isLoading, retry } = useDashboardAccess();
  const { pathname } = useLocation();
  if (isLoading) return <Center mih="100svh"><Loader /></Center>;
  if (!isResolved) return <Center mih="100svh"><Stack align="center">
    <Text>دریافت سطح دسترسی انجام نشد.</Text>
    <Button onClick={retry}>تلاش دوباره</Button>
  </Stack></Center>;
  if (!isManager && !canStylistAccessRoute(pathname)) {
    return <Navigate to="/dashboard/calendar" replace />;
  }
  return children;
}
